export default __webpack_public_path__ + "static/media/secured.db12f312.png";